import PiniaPluginPersistedState from "pinia-plugin-persistedstate"
import { PiniaPluginSyncUrlParams } from "@evercam/shared/stores/piniaPluginSyncUrlParams"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin((app) => {
  app.nuxt2Context.$pinia.use(PiniaPluginPersistedState)
  app.nuxt2Context.$pinia.use(PiniaPluginSyncUrlParams)
})
